import { useFeatureFlagForConsumer } from 'featureFlags/useConsumerFeatureFlag';

export const useHasDirectBrandUpdateFlags = (): boolean => {
  const hasTwilioDirectBrandUpdatesFlag = useFeatureFlagForConsumer('TWILIO_DIRECT_BRAND_UPDATES');
  const hasTwilioDirectBrandDataOnlyFlag = useFeatureFlagForConsumer(
    'TWILIO_DIRECT_BRAND_DATA_ONLY'
  );

  return hasTwilioDirectBrandUpdatesFlag && hasTwilioDirectBrandDataOnlyFlag;
};
